// List of countries (example, adjust as needed based on official sources)
// You might want to use a more comprehensive list or library
export const countries = [
    { code: "MA", name: "Maroc" },
    { code: "DZ", name: "Algérie" }, // Note: Diplomatic relations can be complex.
    { code: "TN", name: "Tunisie" },
    { code: "LY", name: "Libye" },
    { code: "MR", name: "Mauritanie" },
    { code: "EG", name: "Égypte" },
    { code: "SA", name: "Arabie Saoudite" },
    { code: "AE", name: "Émirats Arabes Unis" },
    { code: "QA", name: "Qatar" },
    { code: "KW", name: "Koweït" },
    { code: "OM", name: "Oman" },
    { code: "BH", name: "Bahreïn" },
    { code: "JO", name: "Jordanie" },
    { code: "LB", name: "Liban" },
    { code: "IQ", name: "Irak" }, // Check current diplomatic status if critical
  
    // Europe
    { code: "FR", name: "France" },
    { code: "ES", name: "Espagne" },
    { code: "PT", name: "Portugal" },
    { code: "DE", name: "Allemagne" },
    { code: "IT", name: "Italie" },
    { code: "BE", name: "Belgique" },
    { code: "NL", name: "Pays-Bas" },
    { code: "LU", name: "Luxembourg" },
    { code: "GB", name: "Royaume-Uni" },
    { code: "IE", name: "Irlande" },
    { code: "CH", name: "Suisse" },
    { code: "AT", name: "Autriche" },
    { code: "SE", name: "Suède" },
    { code: "DK", name: "Danemark" },
    { code: "FI", name: "Finlande" },
    { code: "PL", name: "Pologne" },
    { code: "GR", name: "Grèce" },
    { code: "CZ", name: "Tchéquie" },
    { code: "HU", name: "Hongrie" },
    { code: "RO", name: "Roumanie" },
  
    // Americas
    { code: "US", name: "États-Unis" },
    { code: "CA", name: "Canada" },
    { code: "MX", name: "Mexique" },
    { code: "BR", name: "Brésil" },
    { code: "AR", name: "Argentine" },
    { code: "CL", name: "Chili" },
    { code: "CO", name: "Colombie" },
    { code: "PE", name: "Pérou" },
    { code: "VE", name: "Venezuela" }, // Check current diplomatic status if critical
  
    // Asia & Oceania
    { code: "TR", name: "Turquie" },
    { code: "CN", name: "Chine" },
    { code: "JP", name: "Japon" },
    { code: "KR", name: "Corée du Sud" },
    { code: "IN", name: "Inde" },
    { code: "PK", name: "Pakistan" },
    { code: "ID", name: "Indonésie" },
    { code: "MY", name: "Malaisie" },
    { code: "SG", name: "Singapour" },
    { code: "TH", name: "Thaïlande" },
    { code: "AU", name: "Australie" },
    { code: "NZ", name: "Nouvelle-Zélande" },
  
    // Africa (Sub-Saharan)
    { code: "SN", name: "Sénégal" },
    { code: "CI", name: "Côte d'Ivoire" },
    { code: "GH", name: "Ghana" },
    { code: "NG", name: "Nigéria" },
    { code: "CM", name: "Cameroun" },
    { code: "GA", name: "Gabon" },
    { code: "KE", name: "Kenya" },
    { code: "ET", name: "Éthiopie" },
    { code: "ZA", name: "Afrique du Sud" }, // Note: Diplomatic relations can be complex.
  
    // Others
    { code: "RU", name: "Russie" },
    { code: 'other', name: 'Autre' },
    
];

// Function to get country name by code
export const getCountryNameByCode = (code) => {
    const country = countries.find(c => c.code === code);
    return country ? country.name : code; // Return code if name not found
};